import { useTranslation } from 'react-i18next';
import { SelectOption } from '@anytag/shared-types';
import { getSocialMediaText } from '@anytag/shared-utils';
import { CampaignSocialMediaType } from '@anytag/graphql';
import { useTranslateOptions } from '@anytag/shared-hooks';
import { SelectorField, SingleSelectorFieldProps } from '@anytag/shared-molecules';
import { MarketplaceFormKeys } from '../types';

export const SocialMediaField = (
  props: Omit<
    SingleSelectorFieldProps<MarketplaceFormKeys, SelectOption<CampaignSocialMediaType>>,
    'name' | 'options' | 'multiple'
  >
) => {
  const { t } = useTranslation();
  const options: SelectOption<CampaignSocialMediaType>[] = useTranslateOptions(
    [
      CampaignSocialMediaType.FACEBOOK,
      CampaignSocialMediaType.INSTAGRAM,
      CampaignSocialMediaType.YOUTUBE,
      CampaignSocialMediaType.INSTAGRAM_STORY,
      CampaignSocialMediaType.TWITTER,
      CampaignSocialMediaType.TIKTOK
    ].map((value) => ({ value, label: getSocialMediaText(value) }))
  );

  return (
    <SelectorField
      options={options}
      title={t('Selector.Social Media')}
      help={t('Tooltip.Social Media')}
      name={MarketplaceFormKeys.socialMedia}
      {...props}
    />
  );
};
